export const dashboard = {
    alwaysShowDashboard: true,
    displayTabsPage: true,
    displayHeaderLink: false,
    displayedWidgets: {
        default: ['favorites-theme', 'created-theme', 'favorites-lessons', 'consulted-lessons', 'created-lessons', 'favorites-corpus', 'consulted-corpus', 'created-corpus'],
        learner: []
    },
    redirectUrlBasicPage: null
};